import './billing-card.less';
import * as React from 'react';
import { Surface as TlBillingCard } from 'telstra-ui/components/surface/Surface';
import { SurfaceList, SurfaceListItem } from 'telstra-ui/components/list/List';
import { Button } from 'telstra-ui/components/button/Button';
import global from '@applications/global';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import { IconTC } from '@components/icon-tc';

interface ICardLoadingIndicatorProps {
    error: boolean;
    tryAgain?: () => void;
    cardTitle: string;
};

export class BillingCardLoadingIndicator extends React.Component<ICardLoadingIndicatorProps> {

    constructor(props) {
        super(props);
    }

    public render() {
        const { error } = this.props;
        const loadingClassName = 'tl-loading';
        const headerClassName = '__heading ' + loadingClassName;
        const cardHeight = '424px';
        return (
            <div className={`tc-dashboard-cards-container.container panel panel-default tc-billing-rich-card-panel`}
                style={{height: cardHeight}}
            >
                {error ? (<TlBillingCard width="100%"
                    id="ui-billing-card"
                    height={cardHeight}
                    className="tl-custom-width tl-surface-dashboard tc-billing-surface-tile ui-card-error"
                    name="surface-flat">
                    <SurfaceList
                        header={this.renderHeader()}
                        body={this.renderErrorBody()}
                        footer={this.renderFooter()}
                    />
                </TlBillingCard>

                ) : (
                    <TlBillingCard
                        className="tl-custom-width tl-surface-dashboard tc-billing-surface-tile ui-card-loading"
                        id="ui-billing-card"
                        name="surface-flat"
                        height={cardHeight}
                    >
                        <SurfaceList
                            header={
                                <div className="tl-heading__container">
                                    <div className={headerClassName}>Billing</div>
                                </div>
                            }
                            body={
                                <>
                                    <SurfaceListItem
                                        itemHeading={'View bills'}
                                        itemIcon={'icon-system-chevron-right'}
                                        itemId={11}
                                        skeltonLoading={true}
                                    />

                                    <SurfaceListItem
                                        itemHeading={'Billing enquiries'}
                                        itemIcon={'icon-system-chevron-right'}
                                        itemId={12}
                                        skeltonLoading={true}
                                    />
                                </>
                            }
                            footer={
                                <div className="__button tl-list-billing-button">
                                    <Button variant="super" className={loadingClassName} disabled={true} >
                                        View bills</Button>
                                </div>
                            }
                        />
                    </TlBillingCard>
                )}
            </div>
        );
    }

    private renderHeader() {
        return (
            <div className="tl-heading__container">
                <div className="__heading" style={{cursor: 'default'}}>{this.props.cardTitle}</div>
            </div>
        );
    }

    private renderErrorBody() {
        const { error, tryAgain } = this.props;
        return (
            <div className="tc-billing-card-error">
                <div className="tc-billing-card-error__body">
                    <SvgIcon name={'picto-empty-state'}
                        className="tc-telstra-icon tc-billing-card-error__body__icon" />
                    <div className="tc-billing-card-error__body__icon__error"
                        id="ui-billing-card-error-text">
                        {error && tryAgain ? 'Server error' : 'Loading error'}
                    </div>
                    <div className="tc-billing-card-error__body__icon__text"
                        id="ui-billing-card-error-subtext">
                        There was an error loading this app.
                    </div>
                </div>
            </div>
        );
    }

    private renderFooter() {
        const { error, tryAgain } = this.props;
        return error && tryAgain ? (
            <div id="ui-billing-card-try-again"
                className="tc-billing-card-error__button tl-list-im-button"
                onClick={tryAgain}>
                <IconTC name="retry" size="sm-24" className="tc-footer-try-again-icon" />
                <span className="tc-footer-text">Try again</span>
            </div>
        ) : (
            <div id="ui-billing-card-refresh"
                className="tc-billing-card-error__button tl-list-im-button"
                onClick={this.handleErrorCallback()}>
                <SvgIcon name={'icon-system-refresh'} className="tc-footer-refresh-icon" />
                <span className="tc-footer-text">Refresh</span>
            </div>
        );
    }
    private handleErrorCallback() {
        return () => window.location.reload();
    }
}
